import { DAYS_MAP } from '../constants/common';

export const extractKeyFromS3url = (url: string) => {
    const urlObj = new URL(url);
    return urlObj.pathname.split('/').pop();
};

export const generatePostingSummary = (selectedDays: number[], time: string): string => {
    const sortedDays = [...selectedDays].sort((a, b) => a - b);

    const isEveryDay = sortedDays.length === 7;
    const isWeekend = sortedDays.length === 2 && sortedDays.includes(0) && sortedDays.includes(6);
    const isWeekday =
        sortedDays.length === 5 && [1, 2, 3, 4, 5].every((d) => sortedDays.includes(d));

    if (isEveryDay) {
        return `Posting every day at ${time}`;
    } else if (isWeekend) {
        return `Posting every weekend at ${time}`;
    } else if (isWeekday) {
        return `Posting every weekday at ${time}`;
    } else if (sortedDays.length === 1) {
        return `Posting every ${DAYS_MAP[sortedDays[0]]} at ${time}`;
    } else if (sortedDays.length > 1) {
        const dayLabels = sortedDays.map((d) => DAYS_MAP[d]);
        return `Posting every ${dayLabels.join(', ')} at ${time}`;
    } else {
        return `No days selected`;
    }
};

export const parse12HourTime = (timeStr: string): { hours: number; minutes: number } => {
    const [time, modifier] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    minutes++;
    minutes--;

    if (modifier === 'PM' && hours !== 12) {
        hours += 12;
    }
    if (modifier === 'AM' && hours === 12) {
        hours = 0;
    }

    return { hours, minutes };
};

export const generateRandomId = (length = 10) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
};

export const ensureHttpInUrl = (url: string) => {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return 'https://' + url;
    }
    return url;
};
